import { Component, input } from '@angular/core';
import { CompanyAddress } from '@qaroni-app/company/types/company-address';
import { WorkplaceAddress } from '@qaroni-app/workplace/types/workplace-address';

@Component({
  selector: 'qaroni-address-string',
  templateUrl: './address-string.component.html',
  styleUrls: ['./address-string.component.scss'],
  standalone: false,
})
export class AddressStringComponent {
  readonly address = input<CompanyAddress | WorkplaceAddress | null>(null);
  readonly showTitle = input<boolean>(true);
  readonly textClass = input<string>('break-words text-neutral-70 text-base');
}
